interface Props {
  color?: string
  width?: number
  height?: number
}

export const CalendarIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 0C14.2761 0 14.5 0.223858 14.5 0.5V2H19.5C20.3284 2 21 2.67157 21 3.5V19.5C21 20.3284 20.3284 21 19.5 21H1.5C0.671573 21 0 20.3284 0 19.5V3.5C0 2.67157 0.671573 2 1.5 2H6.5V0.5C6.5 0.223858 6.72386 0 7 0C7.27614 0 7.5 0.223858 7.5 0.5V2H13.5V0.5C13.5 0.223858 13.7239 0 14 0ZM1 19.5C1 19.7761 1.22386 20 1.5 20H6.5V15H1V19.5ZM14.5 20H19.5C19.7761 20 20 19.7761 20 19.5V15H14.5V20ZM7.5 20H13.5V15H7.5V20ZM1 14H6.5V9H1V14ZM14.5 14H20V9H14.5V14ZM7.5 14H13.5V9H7.5V14ZM1.5 3C1.22386 3 1 3.22386 1 3.5V8H20V3.5C20 3.22386 19.7761 3 19.5 3H14.5V4.5C14.5 4.77614 14.2761 5 14 5C13.7239 5 13.5 4.77614 13.5 4.5V3H7.5V4.5C7.5 4.77614 7.27614 5 7 5C6.72386 5 6.5 4.77614 6.5 4.5V3H1.5Z"
        fill={color}
      />
    </svg>
  )
}
